import { LegFiJwtService } from '../../../services/auth/legfi-jwt.service';

/** Dedicated ui-v2-* VIEW flag — NOT the `ai-onboarding.tx.enabled` importer flag; the two are decoupled. */
export const TRANSACTIONS_V2_FEATURE_FLAG = 'ui-v2-transactions';

/** Transactions list route for the current org: V2 when flagged in, legacy otherwise. */
export function getTransactionsRoute(): string {
    return LegFiJwtService.featureEnabled(TRANSACTIONS_V2_FEATURE_FLAG)
        ? '/app/transactions-v2'
        : '/app/transactions';
}
